import React from 'react';

interface FormSelectorProps {
    value: string;
    options: any[];
    optionToItemCallback: (option: any) => React.ReactNode;
    label: string;
    onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
    name: string;
    required?: boolean;
    className?: string;
    disabled?: boolean;
}

const FormSelector: React.FC<FormSelectorProps> = ({ 
    value,
    options,
    optionToItemCallback,
    label,
    onChange,
    name,
    required = false,
    className = "",
    disabled = false
}) => {
    return (
        <label className={`floating-label w-full ${className}`}>
            <select
                id={name}
                name={name}
                className="select focus:outline-none"
                value={value}
                onChange={onChange}
                disabled={disabled}
            >
                <option value="" disabled>Select</option>
                {options.map(optionToItemCallback)}
            </select>
            <span className="inline-block align-middle">
                {label}
                {required && <span className="text-error">*</span>}
            </span>
        </label>
    );
};

export default FormSelector;